import React from "react";
import { Link } from "react-router-dom"; // Import Link for routing
import { avatar, DefaultProfile } from "../../../assets/img";

function BidderList({ bids }) {
  console.log("Bidder List ======>", bids);
  
  return (
    <div className="bidder-list">
      {bids.map((bid, index) => (
        <Bidder key={index} bid={bid} />
      ))}
    </div>
  );
}

function Bidder({ bid }) {
  const { amount, userData, usdAmount } = bid;
  const { username, profilePicture, walletAddress } = userData;
  console.log("Bidder Bid =>>>>>>>", bid);

  return (
    <div className="bidder-item d-flex align-items-center justify-content-between trait">
      <div className="avatars space-x-3" style={{ cursor: "pointer" }}>
        <Link to={`/otherProfile/${walletAddress}`} target="_blank">
          <img
            src={profilePicture ? profilePicture : DefaultProfile}
            alt="Avatar"
            className="avatar avatar-sm"
          />
          <span
            className="avatars_name"
            style={{ textTransform: "capitalize" }}
          >
            {username}
          </span>
        </Link>
      </div>
      {/* <div className="bidder-avatar">
        <img src={profilePicture} alt={username}  className="avatar avatar-sm" />
      </div> */}
      <div className="bidder-info">
        {/* <Link to={`/user/${bidder}`}>{username}</Link> */}
        <p>
          {" "}
          {amount} ETH /{usdAmount} USD
        </p>
      </div>
    </div>
  );
}

export default BidderList;
